import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import { Global } from '@emotion/core'
import { withPrefix } from 'gatsby'

// import theme from '../styles/theme'
import globalStyles from '../styles/globalStyles'
import { fontPreloads, fontStyleSheets } from '../styles/fonts'

const Head = () => (
  <Fragment>
    <Helmet
      link={[
        ...fontPreloads,
        ...fontStyleSheets,
        // {
        //   rel: 'dns-prefetch',
        //   href: 'https://www.google-analytics.com',
        // },
        // {
        //   rel: 'dns-prefetch',
        //   href: 'https://www.google.com',
        // },
        {
          type: 'text/plain',
          rel: 'author',
          href: withPrefix('/humans.txt'),
        },
        // {
        //   // It's inlined by gatsby when imported in js
        //   // It doesn't need to be processed so it's ok to keep it in static folder
        //   rel: 'mask-icon',
        //   href: '/safari-pinned-tab.svg',
        //   color: theme.colors.safariPinnedTab,
        // },
        {
          // We are importing apple icon here because:
          // - it should be different than android icon or favicon
          //   (it should be square with a background)
          // - it doesn't need to be processed by sharp
          // - one size is enough
          rel: 'apple-touch-icon',
          sizes: '512x512',
          href: withPrefix('/apple-touch-icon-512x512.png'),
        },
      ]}
    />
    <Helmet>
      <noscript>{`
        <iframe src="//www.googletagmanager.com/ns.html?id=GTM-WDN6LH" height="0" width="0" style="display:none;visibility:hidden"></iframe>
        `}</noscript>
      <script>{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'//www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-WDN6LH');`}</script>
      <script
        async
        src="//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
      ></script>
    </Helmet>
    <Global styles={globalStyles} />
  </Fragment>
)

export default Head
